import React from 'react';
import PageWrapper from '../../../components/page-wrapper/page-wrapper';
import UserList from '../../../components/user-list/user-list';

const UsersPage = () => {
  return (
    <PageWrapper>
      <div className="container mt-5 pt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="mb-4">User Management</h1>
            <UserList />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default UsersPage;